import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import ReactMarkdown from "react-markdown";
import { Row, Col, Card, Container } from "react-bootstrap";
import logo from "../TopNav/volta_insite_logo_2024.png";

/* eslint import/no-webpack-loader-syntax: off */
import CHANGELOG from "!!raw-loader!../../CHANGELOG.md";

export default function ChangeLog({ setDisplayChangeLog }) {
    const [markdown, setMarkdown] = useState(CHANGELOG);

    // Grab All h2's from markdown file
    const versions = [...markdown.matchAll(/^## (.*)/gm)].map((m) => m[1]);

    const onCloseButtonClick = () => {
        setDisplayChangeLog(false);
    };

    return (
        <React.Fragment>
            <Container fluid className="h-100 d-flex flex-column">
                <Row className="my-auto flex-grow-0">
                    <Col className="col-6">
                        <img src={logo} alt="logo" />
                    </Col>
                </Row>
                <Row className="flex-grow-1 overflow-hidden h-100">
                    <Col className="h-100 col-3">
                        <Card className="h-100">
                            <Card.Header>
                                <h2>Jump to Version</h2>
                            </Card.Header>
                            <Card.Body>
                                <ul>
                                    {versions.map((v) => (
                                        <li>
                                            <a href={"#" + v}>{v}</a>
                                        </li>
                                    ))}
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col className="h-100">
                        <Card className="h-100">
                            <Card.Header>
                                <Row>
                                    <Col>
                                        <h1>Version History</h1>
                                    </Col>
                                    <Col className="col-2 align-right align-self-center">
                                        <Button onClick={onCloseButtonClick}>X</Button>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body id="markdown-container" className="overflow-auto flex-grow-1">
                                {/* Read in Markdown file. Apply anchors to all the h2s for linking */}
                                <ReactMarkdown
                                    components={{
                                        h1: () => null,
                                        h2(props) {
                                            return (
                                                <h2>
                                                    <a name={props.children}></a>
                                                    {props.children}
                                                </h2>
                                            );
                                        },
                                    }}
                                >
                                    {markdown}
                                </ReactMarkdown>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="flex-grow-0" style={{ height: "10px" }}></Row>
            </Container>
        </React.Fragment>
    );
}
